"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@cimpress/react-components");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var withTooltip = function withTooltip(tooltip, content) {
  if (!tooltip) {
    return content;
  }

  return _react["default"].createElement(_reactComponents.Tooltip, {
    contents: tooltip
  }, content);
};

var DefaultButton = function DefaultButton(props) {
  var baseButton = _react["default"].createElement("button", {
    autoFocus: !!props.autoFocus,
    className: (0, _classnames["default"])('btn', "btn-".concat(props.bsStyle), {
      'btn-sm': props.size === 'sm',
      'btn-lg': props.size === 'lg',
      'disabled': props.disabled
    }),
    onClick: props.disabled ? undefined : props.onClick
  }, props.icon ? _react["default"].createElement(_react.Fragment, null, props.icon, "\xA0") : null, props.faIcon ? ' ' : null, props.title);

  if (props.disabled && props.disabledTooltip) {
    return withTooltip(props.disabledTooltip, baseButton);
  }

  if (props.tooltip) {
    return withTooltip(props.tooltip, baseButton);
  }

  return baseButton;
};

DefaultButton.propTypes = {
  disabled: _propTypes["default"].bool,
  disabledTooltip: _propTypes["default"].string,
  bsStyle: _propTypes["default"].string,
  title: _propTypes["default"].string,
  size: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  icon: _propTypes["default"].any,
  tooltip: _propTypes["default"].string,
  autoFocus: _propTypes["default"].bool
};
DefaultButton.defaultProps = {
  bsStyle: 'primary'
};
var _default = DefaultButton;
exports["default"] = _default;